import * as http from "@/utils/request";
import { AvatarOwner, CategoryTab } from "@/interfaces/nftTypes";
import { RFResponse, RFResponseCommon } from "@/interfaces/common";
const baseUrl = process.env.NEXT_PUBLIC_BASE_API;

/**
 *  获取头像Tabs
 */
export const getAvatarCategories = async () => {
  const url = `${baseUrl}/profile/api/nft/avatars/lists`;

  try {
    const { code, data } = await http.get<RFResponse<CategoryTab[]>>(url);
    if (code === 200) {
      return data;
    }
    return [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

/**
 * 头像详情
 */
export const getAvatarOwner = async (imageId: string) => {
  const url = `${baseUrl}/profile/api/nft/avatars/detail/${imageId}`;

  try {
    const { code, data } = await http.get<RFResponse<AvatarOwner>>(url);
    if (code == 200) {
      return data;
    }
  } catch (error) {
    console.log(error);
  }
};

/**
 * 头像喜欢
 */
export const avatarLike = async (imageId: string) => {
  const url = `${baseUrl}/profile/api/nft/avatars/desire/${imageId}`;

  try {
    const { code } = await http.post<null, RFResponse<any>>(url);
    return code === 200;
  } catch (error) {
    console.log(error);
    return false;
  }
};

/**
 * 头像不喜欢
 */
export const avatarUnlike = async (imageId: string) => {
  const url = `${baseUrl}/profile/api/nft/avatars/desire/${imageId}`;

  try {
    const { code } = await http._delete<RFResponse<any>>(url);
    return code === 200;
  } catch (error) {
    console.log(error);
    return false;
  }
};

/**
 * 拥有头像
 */
export const avatarOwn = async (imageId: string) => {
  const url = `${baseUrl}/profile/api/nft/avatars/owner/${imageId}`;

  try {
    const { code } = await http.post<null, RFResponse<any>>(url);
    return code === 200;
  } catch (error) {
    console.log(error);
    return false;
  }
};

/**
 * 更改昵称
 */
export const updateNickname = async (nickname: string) => {
  const url = `${baseUrl}/profile/api/users/profile`;

  try {
    const { code } = await http.put<{ nickname: string }, RFResponse<any>>(
      url,
      { nickname }
    );
    return code === 200;
  } catch (error) {
    console.log(error);
    return false;
  }
};

/**
 * 获取用户的入金等级
 */
export const getStarLevelFromServer = async () => {
  const url = `${baseUrl}/profile/api/nft/avatars/depositLevel`;

  try {
    const { code, message, data } = await http.get<
      RFResponseCommon<{ level: number }>
    >(url);
    if (code !== 200) {
      throw Error(message);
    }

    return data.level;
  } catch (error) {
    console.log(error);
    return -1;
  }
};
